<script setup lang="ts">

</script>

<template>
    <svg viewBox="0 0 24 24" fill="currentColor" stroke="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M13.1996 12.0001L22.3496 2.8501C22.6871 2.5126 22.6871 1.9876 22.3496 1.6501C22.0121 1.3126 21.4871 1.3126 21.1496 1.6501L11.9996 10.8001L2.84961 1.6501C2.51211 1.3126 1.98711 1.3126 1.64961 1.6501C1.31211 1.9876 1.31211 2.5126 1.64961 2.8501L10.7996 12.0001L1.64961 21.1501C1.31211 21.4876 1.31211 22.0126 1.64961 22.3501C1.79961 22.5001 2.02461 22.6126 2.24961 22.6126C2.47461 22.6126 2.69961 22.5376 2.84961 22.3501L11.9996 13.2001L21.1496 22.3501C21.2996 22.5001 21.5246 22.6126 21.7496 22.6126C21.9746 22.6126 22.1996 22.5376 22.3496 22.3501C22.6871 22.0126 22.6871 21.4876 22.3496 21.1501L13.1996 12.0001Z"/>
    </svg>
</template>

<style scoped>

</style>
